export const SET_WORKOUTPLAN = "SET_WORKOUTPLAN";
export const CREATE_WORKOUTPLAN = "CREATE_WORKOUTPLAN";
export const WORKOUTPLANS_RECEIVED = "WORKOUTPLANS_RECEIVED";
export const SET_PROPERTY_WORKOUTPLAN = "SET_PROPERTY_WORKOUTPLAN";
